import { Injectable } from '@angular/core';
import { FormGroup, FormControlName } from '@angular/forms';
import { PasswordControl } from './controls/password.control';
import { ConfirmPasswordControl } from './controls/confirm-password.control';

@Injectable()
export class CompletePasswordPresenter {
  form: FormGroup;
  password = new PasswordControl();
  confirmPassword = new ConfirmPasswordControl();
  constructor() {
    this.form = new FormGroup({
      password: this.password,
      confirmPassword: this.confirmPassword
    }, [this.checkPasswords] );
  }

  private checkPasswords(group: FormGroup) {
    const pass = group.get('password').value;
    const confirmPass = group.get('confirmPassword').value;
    return pass === confirmPass ? null : { notSame: true };
  }
}
